/* import __COLOCATED_TEMPLATE__ from './content-snippet.hbs'; */
/* RESPONSIBLE TEAM: team-ai-agent */

import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { BlocksDocument } from '@intercom/composer-ember';
import type { BlockList } from '@intercom/interblocks.ts';
import { ContentSnippetComposerConfig } from 'embercom/components/content-service/composer/content-snippet-editor';
import type IntlService from 'ember-intl/services/intl';

interface ChangeStats {
  additions?: number;
  deletions?: number;
}

interface Args {
  title: string;
  originalContent: Array<Record<string, unknown>>;
  proposedContent: Array<Record<string, unknown>>;
  changeStats: ChangeStats;
}

interface Signature {
  Args: Args;
}

export default class ContentSnippet extends Component<Signature> {
  @service declare intl: IntlService;
  @service intercomEventService: $TSFixMe;

  get proposedBlocksDocument() {
    return new BlocksDocument((this.args.proposedContent || []) as unknown as BlockList);
  }

  get originalBlocksDocument() {
    return new BlocksDocument((this.args.originalContent || []) as unknown as BlockList);
  }

  get proposedContentBlocks(): BlockList {
    return (this.args.proposedContent || []) as unknown as BlockList;
  }

  get prosemirrorComposerConfig() {
    let config = new ContentSnippetComposerConfig({
      eventService: this.intercomEventService,
      intl: this.intl,
      placeholder: '',
    });

    config.isInteractivityDisabled = true;
    config.autoFocus = false;
    return config;
  }

  get hasChanges(): boolean {
    return (
      (this.args.changeStats?.additions ?? 0) > 0 || (this.args.changeStats?.deletions ?? 0) > 0
    );
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'InternalAgent::Content::Proposals::ContentSnippet': typeof ContentSnippet;
    'internal-agent/content/proposals/content-snippet': typeof ContentSnippet;
  }
}
